import { render } from "./ProjectItemSummary.vue?vue&type=template&id=32426ec1&scoped=true"
import script from "./ProjectItemSummary.vue?vue&type=script&lang=js"
export * from "./ProjectItemSummary.vue?vue&type=script&lang=js"

import "./ProjectItemSummary.vue?vue&type=style&index=0&id=32426ec1&scoped=true&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32426ec1"]])

export default __exports__